module.exports = __webpack_public_path__ + "static/media/jeffou.ec8f244f.png";